// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAlarmLowAlarmDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5532 20.6604L41.0709 18.7285C41.6043 18.8715 42.1107 19.0651 42.5861 19.3028C42.7052 19.3624 42.8223 19.4247 42.9375 19.4896C45.4656 20.9161 47.0306 23.6267 47.0019 26.5294C46.9954 27.1895 46.9065 27.8594 46.7277 28.5265L44.7959 28.0089C45.6535 24.8083 43.7543 21.5185 40.5538 20.6606C40.5536 20.6605 40.5534 20.6604 40.5532 20.6604ZM47.5917 46.0017L32.0004 18.1016L16.4091 46.0017L47.5917 46.0017ZM33.7463 17.1259C32.983 15.7601 31.0178 15.7601 30.2545 17.1259L14.6633 45.0261C13.9183 46.3592 14.882 48.0017 16.4091 48.0017H47.5917C49.1188 48.0017 50.0825 46.3592 49.3375 45.0261L33.7463 17.1259Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAlarmLowAlarmDefault is a generated icon component.
 */
let IconMedAlarmLowAlarmDefault = IconMedAlarmLowAlarmDefault_1 = class IconMedAlarmLowAlarmDefault extends IconBaseElement {
    render() {
        return html `${IconMedAlarmLowAlarmDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAlarmLowAlarmDefault.icons = new Map([
    ['s8', _s64IconSvg],
    ['s12', _s64IconSvg],
    ['s16', _s64IconSvg],
    ['s24', _s64IconSvg],
    ['s32', _s64IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedAlarmLowAlarmDefault = IconMedAlarmLowAlarmDefault_1 = __decorate([
    customElement('zui-icon-med-alarm-low-alarm-default')
], IconMedAlarmLowAlarmDefault);
export { IconMedAlarmLowAlarmDefault };
